var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-table__footer" },
    [
      _vm.total
        ? _c("v-pagination", {
            attrs: {
              total: _vm.total,
              "current-page": _vm.page,
              "is-show-total": "",
              "page-size": _vm.pageSize,
              "is-change-size": _vm.isChangeSize,
              "is-input-page": _vm.isInputPage,
              "page-size-options": _vm.pageSizeOptions,
              border: _vm.border,
            },
            on: {
              "change-page": _vm.changePage,
              "change-size": _vm.changeSize,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }